export interface GeneralLedgerAccountModel {
  id: string;
  company_id: string;
  name?: string | null;
  description?: string | null;
  /** Digits kept as text so a leading zero survives, e.g. "0100" (PAUL-3672). */
  code: string;
  type: GeneralLedgerAccountType;
  is_active: boolean;
  /** Optional reporting group (PAUL-3624). Send null to clear the assignment. */
  general_ledger_account_group_id?: string | null;
  /** Read-only echo of the group's name, for rendering a grid column without a second call. Never sent back. */
  general_ledger_account_group_name?: string | null;
  /** PAUL-3045: the VAT everything booked here sells at. Required for Result, optional for Balance, null for Differences. */
  tax_id?: string | null;
  /** Read-only echo of the tax's name. Never sent back. */
  tax_name?: string | null;
  /** Read-only, a fraction: 0.21 for 21%. Never sent back. */
  tax_rate?: number | null;
}

export enum GeneralLedgerAccountType {
  Balance = 0,
  Result = 1,
  // PAUL-2852: books cash-rounding differences.
  Differences = 2,
}

export const GeneralLedgerAccountTypeTranslations = {
  [GeneralLedgerAccountType.Balance]: 'general_ledgers.balance',
  [GeneralLedgerAccountType.Result]: 'general_ledgers.result',
  [GeneralLedgerAccountType.Differences]: 'general_ledgers.differences',
};
